<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Olá! No Monitoramento do Mapeamento Técnico você encontra duas abas e a
        possibilidade de selecionar dois tipos de Monitoramento:
      </h2>
      <div class="d-flex justify-space-around">
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Abas: <br>
          1. <b>Monitoramento Geral</b><br>
          2. <b>Monitoramento por Unidades</b>
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Tipos de Monitoramento: <br>
          1. <b>Responsabilidades</b><br>
          2. <b>Competências Técnicas</b>
        </p>
      </div>
    </div>

    <div>
      <h2>
        1. Monitoramento Geral <br>
        1. Responsabilidades
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba <b>“Monitoramento Geral”</b>, ao selecionar no filtro Tipo de
          Monitoramento <b>“Responsabilidades”</b>, é possível analisar, por
          meio de gráficos e tabelas, os dados referentes ao mapeamento técnico
          das subunidades hierarquicamente vinculadas a sua.
        </p>
        <p class="mx-2 pa-2 text-center font-weight-bold text-lg-h6">
          Gráfico das unidades, pizzas e tabelas
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No gráfico que apresenta as subunidades vinculadas a sua, há dados
          sobre a quantidade de responsabilidades cadastradas, validadas e
          consolidadas, no período de realização do mapeamento técnico, além da
          quantidade de servidores de cada unidade. Na sequência está
          disponibilizada a síntese desses dados em uma tabela.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Nos gráficos de pizzas, podem-se observar os dados referentes ao nível
          de impacto, dificuldade e complexidade das responsabilidades
          consolidadas nas subunidades hierarquicamente vinculadas a sua.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na tabela é possível observar a descrição de todas as
          responsabilidades consolidadas nas subunidades vinculadas a sua, bem
          como as competências técnicas necessárias a execução de cada uma
          delas. É possível ainda utilizar os recursos de ordenação de forma
          crescente ou decrescente por responsabilidade, impacto, dificuldade,
          complexidade, competências e unidades, além de permitir a pesquisa por
          qualquer termo exibido na tabela.
        </p>
      </div>
    </div>

    <div>
      <h2>
        1. Monitoramento Geral <br>
        2. Competências Técnicas
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba <b>“Monitoramento Geral”</b>, ao selecionar no filtro o Tipo de
          Monitoramento <b>“Competências Técnicas”</b>, é possível analisar, por
          meio de gráficos e tabelas, a distribuição das competências técnicas
          consolidadas nas subunidades hierarquicamente vinculadas a sua.
        </p>
        <p class="mx-2 pa-2 text-center font-weight-bold text-lg-h6">
          Gráfico de barras, pizzas e tabelas
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No gráfico de barras, orienta-se observar a recorrência de utilização
          das competências técnicas nas subunidades hierarquicamente vinculadas
          a sua. Recomenda-se ainda observar a diferença entre as cores
          <b>azul</b> (competências técnicas gerais, comuns a várias unidades
          organizacionais) e <b>cinza</b> (competências técnicas inseridas,
          próprias da sua unidade).
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Outra forma de observar as competências técnicas utilizadas nas
          unidades vinculadas a sua é por meio de percentuais representados no
          gráfico pizza. Neste gráfico podem ser visualizadas <b>“todas”</b> as
          competências técnicas, ou selecionar a visualização apenas das
          competências técnicas <b>“gerais”</b>, ou apenas das
          <b>“inseridas”</b>.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na tabela é possível observar de forma mais sintética as competências
          técnicas, e utilizar os recursos de ordenação de forma crescente ou
          decrescente por nome das competências técnicas, tipo ou quantidade.
        </p>
      </div>
    </div>

    <div>
      <h2>Importante!</h2>
      <div class="mx-2 pa-2 justify-center">
        <ul>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar essa aba 1. <b>MONITORAMENTO GERAL</b>,
              monitoramento de 1. <b>Responsabilidades</b>, para ter uma visão
              geral das Responsabilidades das várias subunidades
              hierarquicamente vinculadas a sua.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar essa aba 1. <b>MONITORAMENTO GERAL</b>,
              monitoramento de 2. <b>Competências Técnicas</b>, para ter uma
              visão geral sobre as competências técnicas utilizadas nas várias
              unidades hierarquicamente vinculadas a sua.
            </p>
          </li>
        </ul>
      </div>
    </div>

    <div>
      <h2>
        2. Monitoramento por Unidade <br>
        1. Responsabilidades
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba <b>“Monitoramento por unidade”</b>, você encontra posicionado
          do lado esquerdo o filtro Selecione a unidade, onde você seleciona
          subunidades hierarquicamente vinculadas a sua. Do lado direito, no
          filtro Tipo de Monitoramento, você seleciona
          <b>“Responsabilidades”</b>. Após efetuar estas seleções aparecerão
          gráficos e tabelas com dados referentes ao mapeamento técnico da
          unidade selecionada.
        </p>
        <p class="mx-2 pa-2 text-center font-weight-bold text-lg-h6">
          Gráfico da equipe, pizzas e tabelas
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No gráfico que apresenta a equipe, há dados sobre cargo, função e
          quantidade de responsabilidades cadastradas, validadas e consolidadas
          para a unidade selecionada, no período de realização do mapeamento
          técnico. Na sequência está disponibilizada a síntese desses dados em
          uma tabela.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Nos gráficos pizzas, podem-se observar os dados referentes ao nível de
          impacto, dificuldade e complexidade das responsabilidades consolidadas
          na unidade em análise.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na tabela é possível observar a descrição de todas as
          responsabilidades consolidadas na subunidade selecionada, bem como, as
          competências técnicas necessárias a execução de cada uma delas. É
          permitido ainda utilizar os recursos de ordenação, de forma crescente
          ou decrescente, por responsabilidade, impacto, dificuldade,
          complexidade e competências, além de possibilitar a pesquisa por
          qualquer termo exibido na tabela.
        </p>
      </div>
    </div>

    <div>
      <h2>
        2. Monitoramento por Unidade <br>
        2. Competências Técnicas
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba <b>“Monitoramento por unidade”</b>, você encontra posicionado
          do lado esquerdo o filtro Selecione a unidade, onde você seleciona
          subunidades hierarquicamente vinculadas a sua. Do lado direito, no
          filtro Tipo de Monitoramento, você seleciona
          <b>“Competências Técnicas”</b>. Após efetuar estas seleções aparecerão
          gráficos e tabelas com dados referentes a distribuição das
          Competências Técnicas consolidadas na unidade em análise.
        </p>
        <p class="mx-2 pa-2 text-center font-weight-bold text-lg-h6">
          Gráfico de barras, pizzas e tabelas
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No gráfico de barras, orienta-se observar a recorrência de utilização
          das competências técnicas da unidade selecionada. Recomenda-se ainda
          observar a diferença entre as cores <b>azul</b> (competências técnicas
          gerais, comuns a várias unidades organizacionais) e
          <b>cinza</b> (competências técnicas inseridas, próprias da unidade).
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Outra forma de observar as competências técnicas utilizadas na unidade
          selecionada é por meio de percentuais, representados no gráfico pizza.
          Neste gráfico podem ser visualizadas <b>“todas”</b> as competências
          técnicas, ou selecionar a visualização apenas das competências
          técnicas <b>“gerais”</b>, ou apenas das <b>“inseridas”</b>.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na tabela é possível observar de forma mais sintética as competências
          técnicas e utilizar os recursos de ordenação, de forma crescente ou
          decrescente, por nome das competências técnicas, tipo ou quantidade.
        </p>
      </div>
    </div>

    <div>
      <h2>Importante!</h2>
      <div class="mx-2 pa-2 justify-center">
        <ul>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar essa aba 2. <b>MONITORAMENTO POR UNIDADE</b>,
              monitoramento de 1. <b>Responsabilidades</b>, para acompanhar a
              evolução das responsabilidades cadastradas, validadas e
              consolidadas, bem como, verificar a distribuição do nível de
              impacto, dificuldade e complexidade das responsabilidades
              consolidadas em uma unidade.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar essa aba 2. <b>MONITORAMENTO POR UNIDADE</b>,
              monitoramento 2. <b>Competências Técnicas</b>, para identificar
              quais foram as mais recorrentes em uma unidade.
            </p>
          </li>
        </ul>
      </div>
    </div>

    <div>
      <h2>Orientações Gerais</h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-bold text-lg-h6">
          Você pode trabalhar os dados expostos por meio dos gráficos e tabelas
          com sua equipe no intuito de verificar aspectos de planejamento e
          organização das responsabilidades, bem como orientação sobre as
          competências técnicas necessárias a serem desenvolvidas nas várias
          subunidades vinculadas a sua.
        </p>
      </div>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../../BaseTutorial';

export default {
  name: 'TutorialMonitoramentoMapeamentoGeralResponsabilidade',

  components: { BaseTutorial },

  data() {
    return {
      steps: [
        'Introdução',
        'Monit. Geral - Responsabilidades',
        'Monit. Geral - Competências Técnicas',
        'Importante',
        'Monit. Unidade - Responsabilidades',
        'Monit. Unidade - Competências Técnicas',
        'Importante',
        'Orientações Gerais',
      ],
    };
  },
};
</script>
